import React from "react";
import "./Surrounding.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Surroundingimages from "../../Media/Surrounding/Surrounding";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285136087667&text=Halo%20Alex,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Eastern%20(Surrounding)%20https://marketinggrandeastern.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="surrounding" className="surrounding">
      <div className="slider-regia">
        <Slider {...settings1}>
          {Surroundingimages.map((image, index) => (
            <img className="imagecard" key={index} src={image} alt={image} />
          ))}
        </Slider>
      </div>
      <div className="container-fasilitas">
        <h1>Grand Eastern Surounding Area</h1>
        <hr color="#4d4d4d" />
        <div className="container-desk">
          <div className="desksurrounding">
            Selain menawarkan fasilitas yang menarik, Grand Eastern juga
            dikelilingi dengan berbagai macam fasilitas umum, seperti lingkungan
            pendidikan, kesehatan, tempat hiburan serta akses transportasi guna
            mempermudah penghuni memenuhi kebutuhannya
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;8 Menit ke Kampus Hang Tuah
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;10 Menit ke Sepuluh Nopember Institute of Technology
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;10 Menit Pakuwon City Mall
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;15 Menit ke Galaxy Mall
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;8 Menit ke Onkologi Hospital
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;18 Menit ke Premiere Hospital
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;10 Menit Gotong Royong Hospital
              </span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;25 Menit ke Tol Tambak Sumur
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
